/**
 * Handles size selection in product cards (Nude Project style)
 * Mobile: tap text-block to show sizes overlay
 * Desktop: tap text-block to show floating overlay
 */

document.addEventListener('DOMContentLoaded', function() {
  let isMobile = window.matchMedia('(max-width: 749px)').matches;
  /** @type {HTMLElement | null} */
  let activeCard = null;
  
  /**
   * @param {HTMLElement} card
   */
  function hidePricesInCard(card) {
    try {
      const priceSelectors = [
        '[ref="priceContainer"]',
        '.price',
        '.compare-at-price',
        'product-price',
        '.product-price'
      ];
      /** @type {HTMLElement[]} */
      const nodes = [];
      for (const sel of priceSelectors) {
        const nodeList = card.querySelectorAll(sel);
        for (let i = 0; i < nodeList.length; i++) {
          nodes.push(/** @type {HTMLElement} */ (nodeList[i]));
        }
      }
      const unique = Array.from(new Set(nodes));
      /** @type {{node: HTMLElement, display: string, ariaHidden: string|null}[]} */
      const saved = [];
      unique.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        saved.push({ node, display: node.style.display || '', ariaHidden: node.getAttribute('aria-hidden') });
        node.style.display = 'none';
        node.setAttribute('aria-hidden', 'true');
      });
      /** @type {any} */ (card)._sizesHiddenPrices = saved;
    } catch (e) {
      console.error('hidePricesInCard error', e);
    }
  }

  /**
   * @param {HTMLElement} card
   */
  function restorePricesInCard(card) {
    try {
      const saved = /** @type {any} */ (card)._sizesHiddenPrices;
      if (!saved) return;
      /** @type {{node: HTMLElement, display: string, ariaHidden: string|null}[]} */
      const _saved = saved;
      _saved.forEach((item) => {
        try {
          if (!(item.node instanceof HTMLElement)) return;
          item.node.style.display = item.display || '';
          if (item.ariaHidden === null) {
            item.node.removeAttribute('aria-hidden');
          } else {
            item.node.setAttribute('aria-hidden', item.ariaHidden);
          }
        } catch (e) {}
      });
      /** @type {any} */ (card)._sizesHiddenPrices = null;
    } catch (e) {
      console.error('restorePricesInCard error', e);
    }
  }

  /**
   * @param {HTMLElement} card
   */
  function restoreContainerChildren(card) {
    try {
      // Restore container visibility
      const container = /** @type {HTMLElement | null} */ (card.querySelector('.group-block-content'));
      const targetEl = (container instanceof HTMLElement) ? container : card;
      
      const savedDisplay = /** @type {any} */ (card)._sizesOriginalContainerDisplay;
      const savedVisibility = /** @type {any} */ (card)._sizesOriginalContainerVisibility;
      
      if (savedDisplay !== undefined) {
        targetEl.style.display = savedDisplay || '';
      }
      if (savedVisibility !== undefined) {
        targetEl.style.visibility = savedVisibility || '';
      }
      
      /** @type {any} */ (card)._sizesOriginalContainerDisplay = undefined;
      /** @type {any} */ (card)._sizesOriginalContainerVisibility = undefined;
    } catch (e) {}
  }

  /**
   * @param {HTMLElement} card
   */
  function closeOverlay(card) {
    const floating = /** @type {any} */ (card)._sizesFloatingElement;
    if (floating && floating.parentNode) {
      floating.remove();
    }
    /** @type {any} */ (card)._sizesFloatingElement = null;
    card.classList.remove('product-card--sizes-active');
    restorePricesInCard(card);
    restoreContainerChildren(card);
    if (activeCard === card) {
      activeCard = null;
    }
  }

  // Update mobile state on resize and cleanup
  window.addEventListener('resize', function() {
    const wasMobile = isMobile;
    isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (wasMobile !== isMobile && activeCard) {
      closeOverlay(activeCard);
    }
  });

  // Handle size button clicks
  document.addEventListener('click', function(event) {
    if (!event.target) return;
    const sizeButton = /** @type {HTMLElement} */ (event.target).closest('.product-card-sizes-minimal__size');
    if (!sizeButton || /** @type {HTMLButtonElement} */ (sizeButton).disabled) return;
    const variantUrl = /** @type {HTMLElement} */ (sizeButton).dataset.variantUrl;
    if (variantUrl) {
      window.location.href = variantUrl;
    }
  });
  
  // Handle product card click to toggle sizes
  document.addEventListener('click', function(event) {
    if (!event.target) return;
    const targetElement = /** @type {HTMLElement} */ (event.target);
    const productCard = /** @type {HTMLElement | null} */ (targetElement.closest('.product-card'));
    if (!productCard) return;

    // MOBILE: Non fare nulla, lascia che navighi alla pagina prodotto
    if (isMobile) return;

    // Only trigger when clicking text block
    const clickedInText = targetElement.closest('.text-block');
    if (!clickedInText) return;

    // Don't trigger on interactive elements
    if (targetElement.closest('.product-card-sizes-minimal__size') ||
        targetElement.closest('a:not(.product-card__link)') ||
        targetElement.closest('button:not(.product-card-sizes-minimal__size)')) {
      return;
    }

    const sizesContainer = productCard.querySelector('.product-card-sizes-minimal');
    if (!sizesContainer) return;

    event.preventDefault();
    event.stopPropagation();

    // DESKTOP: floating overlay
    if (!isMobile) {
      // Toggle: if already open, close it
      const existingFloating = /** @type {any} */ (productCard)._sizesFloatingElement;
      if (existingFloating) {
        closeOverlay(productCard);
        return;
      }

      // Close other cards
      if (activeCard && activeCard !== productCard) {
        closeOverlay(activeCard);
      }

      // Create floating overlay
      const floating = /** @type {HTMLElement} */ (sizesContainer.cloneNode(true));
      floating.classList.add('product-card-sizes-floating');
      document.body.appendChild(floating);

      // Position over the entire group-block-content area
      const container = /** @type {HTMLElement | null} */ (productCard.querySelector('.group-block-content'));
      const targetEl = (container instanceof HTMLElement) ? container : productCard;
      const rect = targetEl.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || 0;

      floating.style.position = 'absolute';
      floating.style.left = `${rect.left + scrollLeft}px`;
      floating.style.width = `${rect.width}px`;
      floating.style.height = 'auto';
      floating.style.boxSizing = 'border-box';
      floating.style.zIndex = String(parseInt(getComputedStyle(document.documentElement).getPropertyValue('--layer-temporary')) || 20);

      // Position centered over the entire content area
      const floatingHeight = floating.getBoundingClientRect().height || floating.offsetHeight || 0;
      const topPos = rect.top + scrollTop + (rect.height / 2) - (floatingHeight / 2);
      floating.style.top = `${topPos}px`;

      // Hide ENTIRE container (title, price, swatches, everything)
      if (targetEl instanceof HTMLElement) {
        /** @type {any} */ (productCard)._sizesOriginalContainerDisplay = targetEl.style.display || '';
        /** @type {any} */ (productCard)._sizesOriginalContainerVisibility = targetEl.style.visibility || '';
        targetEl.style.display = 'none';
        targetEl.style.visibility = 'hidden';
      }

      // Close on outside click
      const closeHandler = /** @param {Event} ev */ (ev) => {
        const targetNode = /** @type {Node | null} */ (ev.target instanceof Node ? ev.target : null);
        if (!targetNode || !floating.contains(targetNode)) {
          closeOverlay(productCard);
          document.removeEventListener('click', closeHandler);
        }
      };
      setTimeout(() => document.addEventListener('click', closeHandler), 0);

      /** @type {any} */ (productCard)._sizesFloatingElement = floating;
      productCard.classList.add('product-card--sizes-active');
      hidePricesInCard(productCard);
      activeCard = productCard;
      return;
    }

    // MOBILE: class toggle
    if (productCard.classList.contains('product-card--sizes-active')) {
      closeOverlay(productCard);
      return;
    }

    if (activeCard && activeCard !== productCard) {
      closeOverlay(activeCard);
    }

    productCard.classList.add('product-card--sizes-active');
    hidePricesInCard(productCard);
    activeCard = productCard;
  });
  
  // Prevent bubbling on sizes container
  document.addEventListener('click', function(event) {
    if (!event.target) return;
    const sizesContainer = /** @type {HTMLElement} */ (event.target).closest('.product-card-sizes-minimal');
    if (sizesContainer) {
      event.stopPropagation();
    }
  });

  // Escape key to close
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && activeCard) {
      closeOverlay(activeCard);
    }
  });
});